export default __webpack_public_path__ + "0e5d7e3278d8c86992787b63b341c453.png";